// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__kqord","list":"styles_list__VC4dh"};